import { Tabs } from "antd";
import React, { Component } from "react";
import ApplyHospital from './components/applyHospital'
import ConsulationHospital from './components/consulationHospital'
import OrganizationWork from './components/organizationWork'
import DoctorWork from './components/doctorWork'
import Regulators from './components/regulators'
import PackageCheckList from './components/packageCheckList'
import './statistics.scss'

const { TabPane } = Tabs;

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }


  render() {
    const statisticalType = localStorage.getItem('statisticalType');
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    return (
      <>

        {statisticalType === "监管机构" ? <Regulators /> :
          <Tabs className="tabWrap eleWrap" defaultActiveKey="1" type="card">
            <TabPane key="1" tab="机构工作量统计"><OrganizationWork /></TabPane>
            <TabPane key="2" tab="医生工作量统计"><DoctorWork /></TabPane>
            <TabPane key="3" tab="会诊病例量统计">
              {statisticalType === "申请医院" ? <ApplyHospital /> : null}
              {statisticalType === "会诊医院" ? <ConsulationHospital /> : null}
            </TabPane>
            {statisticalType === "申请医院" && userInfo.HOSPITAL_CODE !== "PLATFORM" ?
              <TabPane key="4" tab="套餐检查量统计">
                <PackageCheckList></PackageCheckList>
              </TabPane> : null
            }
          </Tabs>
        }
      </>
    );
  }
}

export default Statistics;
